import Animation from './Animation.js';
import { LoadingRoot } from './styles.js';
import { LoadingSize, LoadingState, LoadingColors } from './types.js';
import { keyForState, animationForState } from './utilities.js';
import StaticLoading from './static/StaticLoading.js';
import React__default from 'react';
import { ThemingContext } from '@doordash/design-language';
import { useMediaQuery, getPropsToForward } from '@doordash/utilities';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Loading = function Loading(_ref) {
  var color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? LoadingSize.Medium : _ref$size,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? LoadingState.Loading : _ref$state,
      _ref$onAnimationEnd = _ref.onAnimationEnd,
      _onAnimationEnd = _ref$onAnimationEnd === void 0 ? function () {} : _ref$onAnimationEnd,
      _ref$onAnimationLoopE = _ref.onAnimationLoopEnd,
      _onAnimationLoopEnd = _ref$onAnimationLoopE === void 0 ? function () {} : _ref$onAnimationLoopE,
      props = _objectWithoutProperties(_ref, ["color", "size", "state", "onAnimationEnd", "onAnimationLoopEnd"]);

  var theme = React__default.useContext(ThemingContext);
  var prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  var propsToForward = getPropsToForward({
    props: props,
    prefixesToForward: ['data-']
  });

  if (prefersReducedMotion) {
    return /*#__PURE__*/React__default.createElement(StaticLoading, {
      color: color || theme.Colors.LoadingDefault,
      size: size,
      state: state
    });
  }

  return /*#__PURE__*/React__default.createElement(LoadingRoot, _extends({
    color: color || theme.Colors.LoadingDefault,
    state: state
  }, propsToForward), /*#__PURE__*/React__default.createElement(Animation, {
    key: keyForState(state),
    options: animationForState(state),
    width: size,
    height: size,
    onAnimationEnd: function onAnimationEnd() {
      return _onAnimationEnd(keyForState(state));
    },
    onAnimationLoopEnd: function onAnimationLoopEnd() {
      return _onAnimationLoopEnd(keyForState(state));
    }
  }));
};

Loading.Sizes = LoadingSize;
Loading.States = LoadingState;
Loading.Colors = LoadingColors;

export { Loading as default };
